import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemText from "@mui/material/ListItemText";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { PreviousSummary } from "../benefitsSummary.types";

interface PreviousSummariesDrawerProps {
  open: boolean;
  onClose: () => void;
  summaries: PreviousSummary[];
}

const PreviousSummariesDrawer = ({
  open,
  onClose,
  summaries,
}: PreviousSummariesDrawerProps) => (
  <Drawer
    anchor="right"
    open={open}
    onClose={onClose}
    slotProps={{ paper: { sx: { width: { xs: "100%", sm: 420 } } } }}
  >
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      sx={{ p: 2, pl: 3 }}
    >
      <Typography variant="h6" component="h2">
        Previous benefits summaries
      </Typography>
      <IconButton onClick={onClose} aria-label="Close previous summaries">
        <CloseIcon />
      </IconButton>
    </Stack>
    <Divider />
    <Box sx={{ p: 3, pb: 1 }}>
      <Typography variant="body2" color="text.secondary">
        Your most recent summary is on the page. Earlier ones are saved here as
        PDFs.
      </Typography>
    </Box>
    {summaries.length === 0 ? (
      <Typography variant="body2" sx={{ px: 3, py: 2 }}>
        There are no earlier summaries yet.
      </Typography>
    ) : (
      <List sx={{ px: 1 }}>
        {summaries.map((summary) => (
          <ListItem
            key={summary.id}
            secondaryAction={
              <Button
                size="small"
                startIcon={<FileDownloadOutlinedIcon />}
                href={summary.pdfUrl}
                aria-label={`Download ${summary.planName} summary checked ${summary.checkedOn}`}
              >
                PDF
              </Button>
            }
            sx={{ pr: 12 }}
          >
            <ListItemAvatar>
              <Avatar sx={{ bgcolor: "primary.light", color: "primary.main" }}>
                <DescriptionOutlinedIcon />
              </Avatar>
            </ListItemAvatar>
            <ListItemText
              primary={summary.planName}
              secondary={`Checked ${summary.checkedOn}`}
            />
          </ListItem>
        ))}
      </List>
    )}
    <Box sx={{ mt: "auto", p: 3 }}>
      <Typography variant="caption" color="text.secondary" component="p">
        Each PDF shows what your insurance provider told us on the date it was
        checked. It may not match your current plan.
      </Typography>
    </Box>
  </Drawer>
);

export default PreviousSummariesDrawer;
